import { useContext } from "react";
import { TableViewContext, ITableViewContext } from "@/context/TableView";

export function useTableView(): ITableViewContext {
  return useContext(TableViewContext) as ITableViewContext;
}

export default useTableView;
